<template>
  <v-card
    elevation="0"
    class="d-flex flex-column"
    :loading="manager.loading.value"
  >
    <v-card-title class="overflow-visible">
      <div>
        <!-- ================= TOP TOOLBAR ================= -->
        <v-toolbar flat class="overflow-visible">
          <!-- navigation -->
          <v-btn
            color="grey-darken-2"
            size="small"
            variant="text"
            icon
            @click="prev"
          >
            <v-icon size="small">mdi-chevron-left</v-icon>
          </v-btn>

          <v-btn
            color="grey-darken-2"
            size="small"
            variant="text"
            icon
            @click="next"
          >
            <v-icon size="small">mdi-chevron-right</v-icon>
          </v-btn>

          <!-- title -->
          <v-toolbar-title v-if="calendar">
            {{ calendar.title }}
          </v-toolbar-title>

          <!-- ================= DESKTOP FILTERS ================= -->

          <div
            v-if="!isPreview && hasSelectablePeople"
            style="font-size: small"
            class="d-none pa-4 d-xl-flex ga-2"
          >
            <div class="d-flex">
              <v-icon icon="mdi-circle-medium" color="green" />
              <p>Enrolled</p>
            </div>
            <div class="d-flex">
              <v-icon icon="mdi-circle-medium" color="warning" />
              <p>Waitlisted</p>
            </div>
            <div class="d-flex">
              <v-icon icon="mdi-circle-medium" color="blue" />
              <p>Eligibile</p>
            </div>
            <div class="d-flex">
              <v-icon icon="mdi-circle-medium" color="grey" />
              <p>Ineligible</p>
            </div>
          </div>
          <v-select
            v-if="!isPreview && hasSelectablePeople"
            chips
            multiple
            hide-details="auto"
            density="compact"
            variant="outlined"
            class="d-none d-xl-block"
            label="Showing:"
            width="40"
            :items="filterTypes"
            v-model="manager.filterType.value"
          />

          <v-select
            v-if="!isPreview && showSelectPerson"
            chips
            multiple
            hide-details="auto"
            persistent-hint
            class="d-none d-xl-block mx-4 overflow-visible"
            height="100"
            variant="outlined"
            density="compact"
            width="40"
            label="For:"
            :items="manager.selectablePeople.value"
            v-model="manager.peopleSelected.value"
          />
          <v-spacer />
          <!-- actions -->
          <v-btn
            class="mr-4"
            color="grey-darken-2"
            variant="outlined"
            @click="setToday"
          >
            Today
          </v-btn>

          <v-menu location="bottom end">
            <template #activator="{ props }">
              <v-btn color="grey-darken-2" variant="outlined" v-bind="props">
                {{ typeToLabel[type] }}
                <v-icon end>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
        <!-- ================= MOBILE FILTER ROW ================= -->
        <v-expand-transition v-if="!isPreview && hasSelectablePeople">
          <div class="d-xl-none pt-2 ga-4">
            <div style="font-size: xx-small" class="d-flex ga-2">
              <div class="d-flex">
                <v-icon icon="mdi-circle-medium" color="green" />
                <p>Enrolled</p>
              </div>
              <div class="d-flex">
                <v-icon icon="mdi-circle-medium" color="warning" />
                <p>Waitlisted</p>
              </div>
              <div class="d-flex">
                <v-icon icon="mdi-circle-medium" color="blue" />
                <p>Eligibile</p>
              </div>
              <div class="d-flex">
                <v-icon icon="mdi-circle-medium" color="grey" />
                <p>Ineligible</p>
              </div>
            </div>
            <v-select
              v-if="!isPreview"
              chips
              multiple
              hide-details="auto"
              density="compact"
              variant="outlined"
              label="Showing:"
              width="100%"
              class="flex-grow-1 pt-2"
              :items="filterTypes"
              v-model="manager.filterType.value"
            />

            <v-select
              v-if="!isPreview && showSelectPerson"
              chips
              multiple
              hide-details="auto"
              density="compact"
              variant="outlined"
              label="For:"
              width="100%"
              class="flex-grow-1 pt-2"
              :items="manager.selectablePeople.value"
              v-model="manager.peopleSelected.value"
            />
          </div>
        </v-expand-transition>
      </div>
    </v-card-title>
    <v-card-text class="overflow-y-scroll">
      <v-sheet :style="{ minHeight: '400px' }">
        <div v-if="mobileDayView" class="mobile-day-list">
          <div
            class="mobile-day-header text-subtitle-1 font-weight-medium px-2 pb-2"
          >
            {{ formatDayHeader(manager.focus.value) }}
          </div>
          <div
            v-if="!mobileDayEvents.length"
            class="text-medium-emphasis text-center py-8"
          >
            No classes on this day
          </div>
          <v-list v-else density="compact" class="py-0">
            <template
              v-for="event in mobileDayEvents"
              :key="mobileEventKey(event)"
            >
              <v-list-item
                v-if="isGuidedSailEvent(event)"
                class="mobile-day-row px-2"
                :style="{ borderLeft: '4px solid teal' }"
              >
                <div class="d-flex align-center flex-nowrap ga-2">
                  <span class="mobile-day-time text-caption">All day</span>
                  <span class="text-body-2 text-truncate flex-grow-1">{{
                    event.name
                  }}</span>
                  <v-btn
                    size="small"
                    variant="tonal"
                    color="teal"
                    @click="showEvent($event, { event })"
                    >Sign up</v-btn
                  >
                </div>
              </v-list-item>
              <v-list-item
                v-else
                class="mobile-day-row px-2"
                :class="{ 'cursor-pointer': mode === 'custom' }"
                :style="{ borderLeft: `4px solid ${eventCssColor(event)}` }"
                @click="
                  mode === 'custom'
                    ? emit('classClicked', event.rawClass)
                    : undefined
                "
              >
                <div class="d-flex align-center flex-nowrap ga-2">
                  <span class="mobile-day-time text-caption">
                    {{ formatTimeRange(event.rawSession) }}
                  </span>
                  <span
                    class="mobile-day-name text-body-2 text-truncate"
                    :title="getClassName(event.rawClass)"
                  >
                    {{ getClassName(event.rawClass) }}
                  </span>
                  <v-chip
                    v-if="hasSelectablePeople"
                    size="x-small"
                    variant="flat"
                    class="flex-shrink-0"
                    :color="eventStatus(event).color"
                  >
                    {{ eventStatus(event).label }}
                  </v-chip>
                  <div
                    v-if="mode !== 'custom'"
                    class="mobile-day-actions d-flex flex-nowrap align-center ga-1"
                    @click.stop
                  >
                    <class-calendar-actions
                      :eligibility="
                        manager.selectableEligibility(event.rawEligibility)
                      "
                      :class-instance="event.rawEligibility.classInstance"
                      :loading="manager.loading.value"
                      :update-enrollment="
                        (t, personId) => updateEnrollmentFor(event, t, personId)
                      "
                      :update-instructor-enrollment="
                        (isEnroll, personId) =>
                          updateInstructorEnrollmentFor(
                            event,
                            isEnroll,
                            personId,
                          )
                      "
                      :get-name="getName"
                    />
                  </div>
                  <v-btn
                    size="small"
                    variant="text"
                    density="comfortable"
                    class="flex-shrink-0 ml-auto"
                    aria-label="More info"
                    title="More info"
                    :icon="
                      expandedEvents.has(mobileEventKey(event))
                        ? 'mdi-chevron-up'
                        : 'mdi-information-outline'
                    "
                    @click.stop="toggleExpanded(event)"
                  />
                </div>
                <v-expand-transition>
                  <div
                    v-if="expandedEvents.has(mobileEventKey(event))"
                    class="text-body-2 pt-2 pb-1"
                  >
                    <p>
                      <strong>{{ getClassName(event.rawClass) }}</strong>
                    </p>
                    <p v-if="event.rawClass.instructorName">
                      <strong>Instructor:</strong>
                      {{ event.rawClass.instructorName }}
                    </p>
                    <p><strong>Class meets on:</strong></p>
                    <p
                      v-for="session in getCalendarSessions(event.rawClass)"
                      :key="String(session.sessionDatetime)"
                    >
                      {{ formatDateNY(session.sessionDatetime) }} from
                      {{ formatTimeNY(session.sessionDatetime) }}-{{
                        formatTimeNY(session.endDatetime)
                      }}
                    </p>
                    <class-availability-details
                      class="pt-2"
                      :availability="event.rawClass.availability"
                    />
                  </div>
                </v-expand-transition>
              </v-list-item>
              <v-divider />
            </template>
          </v-list>
        </div>
        <v-calendar
          v-show="!mobileDayView"
          ref="calendar"
          v-model="manager.focus.value"
          :events="events"
          :type="type"
          @click:event="showEvent"
          @click:more="showMore"
          @click:date="showMore"
          color="primary"
        >
        </v-calendar>
        <v-menu
          v-model="selectedOpen"
          :activator="selectedElement"
          :close-on-content-click="false"
          location="end"
        >
          <!-- Guided Sail Modal -->
          <v-card
            v-if="selectedGuidedSailEventRef?.isGuidedSail"
            color="grey-lighten-4"
            min-width="350px"
            flat
          >
            <v-toolbar color="teal" dark>
              <v-toolbar-title>
                <h3>Guided Sail Instructor Signup</h3>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <p class="mb-3">
                <strong>Select a timeslot:</strong>
              </p>
              <v-select
                v-model="selectedGuidedSailTimeslot"
                :items="currentGuidedSailTimeslotOptions"
                label="Available Timeslots"
                variant="outlined"
                density="comfortable"
                clearable
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="selectedGuidedSailTimeslot"
                @click="handleGuidedSailEnrollment"
                color="teal"
                prepend-icon="mdi-sail-boat"
                :loading="manager.loading.value"
                block
              >
                Confirm Guided Sail Session
              </v-btn>
              <v-btn v-else @click="selectedOpen = false" block>Cancel</v-btn>
            </v-card-actions>
          </v-card>

          <!-- Regular Class Modal -->
          <v-card v-else color="grey-lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent?.color" dark>
              <v-toolbar-title>
                <h3>
                  {{
                    selectedEvent?.rawClass?.weekNumber
                      ? "Week " + selectedEvent?.rawClass.weekNumber
                      : ""
                  }}
                  {{ selectedEvent?.rawClass?.className }}
                </h3>
                <div class="d-flex flex-col justify-space-between pr-6">
                  <h6>Class #{{ selectedEvent?.rawClass.classId }}</h6>
                  <h6 v-if="selectedEvent?.rawClass?.instructorName">
                    Instructor:
                    {{ selectedEvent.rawClass.instructorName }}
                  </h6>
                </div>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div>
                <p><strong>Class meets on:</strong></p>
                <p
                  v-for="session in getCalendarSessions(
                    selectedEvent!!.rawClass,
                  )"
                >
                  {{ formatDateNY(session.sessionDatetime) }} from
                  {{ formatTimeNY(session.sessionDatetime) }}-{{
                    formatTimeNY(session.endDatetime)
                  }}
                </p>
                <class-availability-details
                  class="pt-2"
                  :availability="selectedEvent!!.rawClass.availability"
                />
              </div>
            </v-card-text>
            <v-card-actions>
              <class-calendar-actions
                v-if="selectedEvent"
                :eligibility="
                  manager.selectableEligibility(selectedEvent.rawEligibility)
                "
                :class-instance="selectedEvent.rawEligibility.classInstance"
                :loading="manager.loading.value"
                :update-enrollment="updateEnrollmentCalendar"
                :update-instructor-enrollment="
                  updateInstructorEnrollmentCalendar
                "
                :get-name="getName"
              />
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-card-text>
  </v-card>
  <v-dialog v-model="checkoutOpen" max-width="1400" persistent>
    <StaffOrderShop
      v-if="checkoutOpen && manager.checkoutOrder.value"
      :order-id="manager.checkoutOrder.value.assignId"
      @close="closeCheckout"
      @complete="refreshEnrollment"
    />
  </v-dialog>
</template>
<script lang="ts" setup>
import { SignupTypeEnum } from "../../../cbi-generator/generated/dto/SignupTypeEnum";
import type { GuidedSailSlot } from "../../../cbi-generator/generated/dto/GuidedSailSlot";
import { ClassEligibilityStatus } from "../../../cbi-generator/generated/dto/ClassEligibilityStatus";
import { ClassInstructorEligibilityStatus } from "../../../cbi-generator/generated/dto/ClassInstructorEligibilityStatus";
import { useDisplay } from "vuetify";

import { CalendarEvent } from "vuetify/lib/components/VCalendar/types.mjs";
import { useAuthStore } from "@/stores/auth";
import { useUser } from "@/composables/useUser";
import { useUtility } from "@/composables/useUtility";
import { AxiosResponse } from "axios";
import {
  filterTypeAllParticipants,
  filterTypeAllClasses,
  filterTypeShoppingCart,
  filterTypeEnrolled,
  filterTypeWaitlisted,
  filterTypeEligible,
  filterTypeIneligible,
  filterTypesRaw,
  filterTypes,
  useClassManager,
  CombinedClassType,
  ClassManager,
  CalendarClass,
  CalendarEventWithRaw,
  getCalendarSessions,
  isSameClass,
  programTypeToLegacyId,
} from "@/composables/classes/useClassManager";
const props = defineProps<{
  manager: ClassManager;
  mode?: "default" | "custom";
  selectedClassInstance?: { instanceId: number; programId: number } | null;
}>();
const router = useRouter();
const checkoutOpen = ref(false);
watch(props.manager.checkoutOrder, (order) => {
  if (order) checkoutOpen.value = true;
});
async function refreshEnrollment() {
  await props.manager.fetchClassEnrollmentAndEligibility(true);
}
function closeCheckout() {
  checkoutOpen.value = false;
  props.manager.clearCheckoutOrder();
  refreshEnrollment();
}

const emit = defineEmits<{
  (e: "classClicked", classInstance: CalendarClass): void;
}>();
type CalendarType = "month" | "week" | "day";

type GuidedSailEventWithRaw = CalendarEvent & {
  isGuidedSail: true;
  rawSlots: GuidedSailSlot[];
};
const calendar = ref();
const { mobile } = useDisplay();
const type = ref<CalendarType>(mobile.value ? "day" : "month");
const selectedEvent = computed({
  get: () => {
    const eventFromArray = events.value.find(
      (event): event is CalendarEventWithRaw =>
        "rawClass" in event &&
        isSameClass(event.rawClass, selectedEventRef.value?.rawClass),
    );
    return eventFromArray || selectedEventRef.value;
  },
  set: (v: CalendarEventWithRaw | GuidedSailEventWithRaw) => {
    selectedEventRef.value = v as CalendarEventWithRaw;
    selectedGuidedSailEventRef.value = v as GuidedSailEventWithRaw;
  },
});
const selectedEventRef = ref<CalendarEventWithRaw>();
const selectedGuidedSailEventRef = ref<GuidedSailEventWithRaw>();
const selectedElement = ref<Element>();
const selectedOpen = ref(false);

const selectedGuidedSailTimeslot = ref<Date | null>(null);

const currentGuidedSailTimeslotOptions = computed(() => {
  if (!selectedGuidedSailEventRef.value?.isGuidedSail) return [];
  return selectedGuidedSailEventRef.value.rawSlots.map((slot) => ({
    title: `${formatDateNY(slot.start)} ${formatTimeNY(slot.start)} - ${formatTimeNY(slot.end)}`,
    value: slot.start,
  }));
});

const {
  peopleSelectedRef,
  selectedPeopleIds,
  getName,
  getClassColor,
  getClassName,
  updateEnrollment,
  updateInstructorEnrollment,
  enrollGuidedSailInstructor,
  guidedSailTimeslots,
} = props.manager;

const hasSelectablePeople = computed(
  () => props.manager.hasSelectablePeople.value,
);

const showSelectPerson = computed(
  () =>
    hasSelectablePeople.value &&
    props.manager.selectablePeople.value.length > 2,
);

const { formatDateNY, formatTimeNY } = useUtility();

const userStore = useUser();

const auth = useAuthStore();

const isPreview = computed(() => !auth.isAuthenticated());

function getEventClasses(): CalendarEventWithRaw[] {
  // If no selectable people, show all classes
  const classesToShow = hasSelectablePeople.value
    ? props.manager.personClasses.value
    : props.manager.allClasses.value;

  return classesToShow.flatMap((personClass) =>
    getCalendarSessions(personClass.classInstance).map((session) => ({
      name: getClassName(personClass.classInstance),
      color: getClassColorCalendar(personClass),
      start: new Date(session.sessionDatetime),
      end: session.endDatetime,
      timed: true,
      rawSession: session,
      rawClass: personClass.classInstance,
      rawEligibility: personClass,
    })),
  );
}

function getGuidedSailEvents(): GuidedSailEventWithRaw[] {
  return guidedSailTimeslots.value.map((day) => ({
    name: "Guided Sail Instructor Signup",
    color: "teal",
    start: day.date,
    end: day.date,
    allDay: true,
    isGuidedSail: true as const,
    rawSlots: [...day.slots],
  }));
}

const events = computed(() => {
  return [...getEventClasses(), ...getGuidedSailEvents()];
});

const mobileDayView = computed(() => mobile.value && type.value === "day");
const mobileDayEvents = computed(() => getEventsForDay());
const expandedEvents = ref(new Set<string>());

type DayEvent = CalendarEventWithRaw | GuidedSailEventWithRaw;

function isGuidedSailEvent(event: DayEvent): event is GuidedSailEventWithRaw {
  return "isGuidedSail" in event && event.isGuidedSail === true;
}

function mobileEventKey(e: DayEvent) {
  if (isGuidedSailEvent(e)) return "guided-" + new Date(e.start).getTime();
  return [
    e.rawClass.programType,
    e.rawClass.classId,
    new Date(e.rawSession.sessionDatetime).getTime(),
  ].join("-");
}

function toggleExpanded(event: DayEvent) {
  const key = mobileEventKey(event);
  const next = new Set(expandedEvents.value);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  expandedEvents.value = next;
}

const themeColors = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
];
function eventCssColor(event: CalendarEvent) {
  const color = String(event.color ?? "grey");
  return themeColors.includes(color) ? `rgb(var(--v-theme-${color}))` : color;
}

function eventStatus(event: CalendarEventWithRaw) {
  const selected = props.manager.selectableEligibility(event.rawEligibility);
  const has = (status: ClassEligibilityStatus) =>
    selected.some((e) => e.status == status);
  if (
    selected.some(
      (e) => e.instructorStatus == ClassInstructorEligibilityStatus.ENROLLED,
    )
  )
    return { label: "Instructing", color: "purple" };
  if (
    has(ClassEligibilityStatus.WAITLISTED) ||
    has(ClassEligibilityStatus.WAITLISTED_PENDING)
  )
    return { label: "Waitlisted", color: "warning" };
  if (has(ClassEligibilityStatus.ENROLLED))
    return { label: "Enrolled", color: "green" };
  if (has(ClassEligibilityStatus.PURCHASE_HOLD))
    return { label: "On hold", color: "blue" };
  if (has(ClassEligibilityStatus.ELIGIBLE))
    return { label: "Eligible", color: "primary" };
  return { label: "Ineligible", color: "grey" };
}

function formatDayHeader(date: Date | string | undefined) {
  if (!date) return "";
  return new Date(date).toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
}

/** "2:00-4:00 PM", keeping both meridiems only when they differ. */
function formatTimeRange(session: CalendarEventWithRaw["rawSession"]) {
  const start = formatTimeNY(session.sessionDatetime) ?? "";
  const end = formatTimeNY(session.endDatetime) ?? "";
  const startSuffix = start.slice(-2);
  return startSuffix === end.slice(-2)
    ? `${start.slice(0, -3)}-${end}`
    : `${start}-${end}`;
}

function getEventsForDay(): DayEvent[] {
  if (!props.manager.focus.value) return [];
  const dayStart = new Date(props.manager.focus.value);
  dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(props.manager.focus.value);
  dayEnd.setHours(23, 59, 59, 999);

  return events.value
    .filter((e) => {
      const start = new Date(e.start);
      const end = new Date(e.end);
      return start <= dayEnd && end >= dayStart;
    })
    .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
}

function scrollToFirstEvent() {
  nextTick(() => {
    const container = calendar.value?.$el.querySelector(
      ".v-calendar-daily__scroll-area",
    );
    const firstEventEl = container?.querySelector(".v-event-timed"); // or '.v-event-wrapper'
    if (container && firstEventEl) {
      container.scrollTop = firstEventEl.offsetTop;
    }
  });
}

const showTimes = computed(() => type.value == "day");

// Scroll when the component mounts
onMounted(() => {
  scrollToFirstEvent();
});

const typeToLabel = {
  month: "Month",
  week: "Week",
  day: "Day",
};

function addHours(date: Date, hours: number) {
  date.setHours(date.getHours() + hours);
  return date;
}

onMounted(() => {
  calendar.value.checkChange();
});

function getClassColorCalendar(personClassesEligibility: CombinedClassType) {
  const isSelectedInMenu =
    selectedOpen.value &&
    isSameClass(
      selectedEventRef.value?.rawClass,
      personClassesEligibility.classInstance,
    );

  // Check if this class is the selected instance (from props)
  const isSelectedInstance =
    props.selectedClassInstance &&
    personClassesEligibility.classInstance.classId ==
      props.selectedClassInstance.instanceId &&
    programTypeToLegacyId(personClassesEligibility.classInstance.programType) ==
      props.selectedClassInstance.programId;

  return isSelectedInstance
    ? "purple"
    : getClassColor(personClassesEligibility, isSelectedInMenu);
}

const currentMonth = ref<number>();

function refreshedEligibility(rawClass: CalendarClass) {
  return props.manager.allClasses.value.find((a) =>
    isSameClass(a.classInstance, rawClass),
  );
}

async function updateEnrollmentFor(
  event: CalendarEventWithRaw,
  type: SignupTypeEnum | undefined,
  personId: number,
) {
  let requiresPayment = false;
  try {
    requiresPayment = await updateEnrollment(type, personId, event.rawClass);
  } catch {
    // Already reported by the class manager.
  }
  const updated = refreshedEligibility(event.rawClass);
  if (updated) event.rawEligibility = updated;
  if (requiresPayment && auth.accessToken?.audience === "AUDIENCE_MEMBER")
    await router.push({ name: "portal-cart" });
}

async function updateInstructorEnrollmentFor(
  event: CalendarEventWithRaw,
  isEnroll: boolean,
  personId: number,
) {
  await updateInstructorEnrollment(isEnroll, personId, event.rawClass);
  const updated = refreshedEligibility(event.rawClass);
  if (updated) event.rawEligibility = updated;
}

async function updateEnrollmentCalendar(
  type: SignupTypeEnum | undefined,
  personId: number,
) {
  const event = selectedEvent.value as CalendarEventWithRaw | undefined;
  if (event) await updateEnrollmentFor(event, type, personId);
  selectedOpen.value = false;
}

async function updateInstructorEnrollmentCalendar(
  isEnroll: boolean,
  personId: number,
) {
  const event = selectedEvent.value as CalendarEventWithRaw | undefined;
  if (event) await updateInstructorEnrollmentFor(event, isEnroll, personId);
  selectedOpen.value = false;
}

async function handleGuidedSailEnrollment() {
  if (selectedGuidedSailTimeslot.value) {
    await enrollGuidedSailInstructor(selectedGuidedSailTimeslot.value, () => {
      selectedOpen.value = false;
    });
    // Close modal and cleanup AFTER the async operation completes
    // This prevents Vue from trying to update components that are being cleaned up
    selectedOpen.value = false;
    selectedGuidedSailTimeslot.value = null;
    // Wait a tick before clearing the event reference to avoid component update errors
    await nextTick();
    selectedGuidedSailEventRef.value = undefined;
  }
}

function showMore(nativeEvent: any, event: any) {
  // Logic to open a dialog or show more details for the specific date
  console.log("More events clicked for date:", event);
  props.manager.focus.value = new Date(event.year, event.month - 1, event.day);
  type.value = "day";
  console.log(nativeEvent);
  scrollToFirstEvent();
  // You can use the date to filter all events and display them in a list
}

function showEvent(nativeEvent: any, { event }: any) {
  console.log(event);

  // If in custom mode, emit the event instead of opening the menu
  if (props.mode === "custom") {
    emit("classClicked", event.rawClass);
    nativeEvent.stopPropagation();
    return;
  }

  // Default mode - show the menu
  const open = () => {
    selectedEvent.value = event;
    selectedElement.value = nativeEvent.target;
    requestAnimationFrame(() =>
      requestAnimationFrame(() => (selectedOpen.value = true)),
    );
  };
  if (selectedOpen.value) {
    selectedOpen.value = false;
    requestAnimationFrame(() => requestAnimationFrame(() => open()));
  } else {
    open();
  }
  nativeEvent.stopPropagation();
}

onMounted(() => {
  calendar.value.checkChange();
});

function viewDay(nativeEvent: any, { date }: any) {
  props.manager.focus.value = date;
  type.value = "day";
}

function setToday() {
  props.manager.focus.value = new Date();
}

function prev() {
  if (type.value == "month") {
    const date = new Date(props.manager.focus.value);
    date.setMonth(date.getMonth() - 1);
    props.manager.focus.value = date;
  } else {
    calendar.value.prev();
  }
}

function next() {
  if (type.value == "month") {
    const date = new Date(props.manager.focus.value);
    date.setMonth(date.getMonth() + 1);
    props.manager.focus.value = date;
  } else {
    calendar.value.next();
  }
}
</script>

<style scoped>
.mobile-day-time {
  flex-shrink: 0;
  white-space: nowrap;
}
.mobile-day-name {
  flex: 1 1 auto;
  min-width: 48px;
}
.mobile-day-actions {
  flex: 0 0 auto;
  max-width: 50%;
  min-width: 0;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
}
.mobile-day-actions :deep(.v-chip) {
  height: 24px;
  font-size: 0.75rem;
  flex-shrink: 0;
}
.mobile-day-actions :deep(.v-chip .v-btn) {
  height: auto;
  min-width: 0;
  padding: 0;
  font-size: inherit;
  letter-spacing: normal;
}
.mobile-day-actions :deep(> div) {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
}
</style>
